// function to check if an element is visible in the viewport.
function isInViewport(element, option = 1) {
  const rect = element.getBoundingClientRect();
  if (option == 1) {
    return rect.bottom >= 0;
  } else if (option == 2) {
    return rect.bottom >= 0 && rect.top < window.innerHeight;
  } else if (option == 3) {
    return rect.bottom >= 0 && rect.top < window.innerHeight;
  }
}

// function to set cookie into the cilent's browser.
function setCookie(cookieName, cookieValue) {
  var d = new Date();
  d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}

// function to replace the browser's URL to the updated product handle.
function renderNewUrl(e) {
  if (e?.getAttribute("product-handle")) {
    const handle = e.getAttribute("product-handle");
    const root = window.Shopify?.routes?.root || "/";
    let nextUrl = root + "products/" + handle;

    if (isClearanceMode()) {
      const urlObj = new URL(nextUrl, window.location.origin);
      urlObj.searchParams.set("clearance", "1");
      nextUrl = urlObj.pathname + urlObj.search;
    }

    window.history.replaceState("data", handle, nextUrl);
  }
}

function isClearanceMode() {
  return (
    window.clearanceModeRequested === true ||
    new URLSearchParams(window.location.search).get("clearance") === "1"
  );
}

function getClearanceHandles() {
  return Array.isArray(window.clearanceHandles) ? window.clearanceHandles : [];
}

function isHandleOnClearance(handle) {
  if (!handle) {
    return false;
  }

  return getClearanceHandles().includes(handle);
}

function appendClearanceQuery(url) {
  if (!isClearanceMode()) {
    return url;
  }

  const separator = url.includes("?") ? "&" : "?";
  return url + separator + "clearance=1";
}

var _clearanceSelectionEnsured = false;

function applyClearanceMode(mainDOM = document) {
  if (!isClearanceMode()) {
    return;
  }

  document.body.classList.add("clearance-pdp-mode");

  mainDOM.querySelectorAll(".other-product-options.swatch-option").forEach((radio) => {
    const handle = radio.getAttribute("product-handle");
    const labelObj = mainDOM.querySelector(`[for="${radio.id}"]`);

    if (!labelObj) {
      return;
    }

    if (handle && !isHandleOnClearance(handle)) {
      labelObj.classList.add("other-options-hidden");
      radio.disabled = true;

      if (radio.classList.contains("selected")) {
        radio.classList.remove("selected");
        radio.checked = false;
      }
    }
  });

  handleClearanceEmptyState(mainDOM);
}

function ensureClearanceSelection() {
  if (!isClearanceMode() || _clearanceSelectionEnsured) {
    return;
  }

  const handles = getClearanceHandles();
  if (!handles.length) {
    _clearanceSelectionEnsured = true;
    return;
  }

  const currentHandle =
    window.currentProductHandle ||
    (typeof current_product_json !== "undefined"
      ? current_product_json.handle
      : null);

  if (currentHandle && isHandleOnClearance(currentHandle)) {
    _clearanceSelectionEnsured = true;
    return;
  }

  _clearanceSelectionEnsured = true;
  const root = window.Shopify?.routes?.root || "/";
  const targetUrl = new URL(root + "products/" + handles[0], window.location.origin);
  targetUrl.searchParams.set("clearance", "1");
  window.location.replace(targetUrl.toString());
}

function handleClearanceEmptyState(mainDOM = document) {
  if (!isClearanceMode()) {
    return;
  }

  const emptyState = mainDOM.querySelector("[data-clearance-empty-state]");
  const banner = mainDOM.querySelector("[data-clearance-banner]");

  if (!getClearanceHandles().length) {
    document.body.classList.add("clearance-pdp-empty");
    if (emptyState) {
      emptyState.hidden = false;
    }
    if (banner) {
      banner.hidden = true;
    }
    return;
  }

  document.body.classList.remove("clearance-pdp-empty");
  if (emptyState) {
    emptyState.hidden = true;
  }
  if (banner) {
    banner.hidden = false;
  }
}

// function to get cookies from the cilent's browser.
function getCookieValue(cookieName) {
  var name = cookieName + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "0";
}

// Color swatch related function
function getStoreCurrentOptions() {
  var arrSelectedValues = [];
  var elementsToPointout = document.getElementsByClassName(
    "single-varinat-option "
  );
  var customAttributeValue = "";
  for (
    var iElementsToPointout = 0;
    iElementsToPointout < elementsToPointout.length;
    iElementsToPointout++
  ) {
    var parentElement = elementsToPointout[iElementsToPointout];
    if (parentElement) {
      customAttributeValue = parentElement.getAttribute("data-option-key-name");
      var radioSelector = 'input[type="radio"]:checked';

      var selectedRadio = parentElement.querySelector(radioSelector);
      if (selectedRadio) {
        var selectedOptionValue = selectedRadio.value;
      }
    }
    var jsonObject2 = {};
    jsonObject2[customAttributeValue] = selectedOptionValue;
    // Push the second JSON object into the array
    arrSelectedValues.push(jsonObject2);
  }
  setCookie("web-variant-selected", JSON.stringify(arrSelectedValues));
}

function updateDOMPrice() {
  if (
    typeof currency_format != "undefined" &&
    document
      ?.querySelector(".configuration-price")
      ?.querySelector(".price-list")
      ?.getAttribute("final-price")
  ) {
    let priceDiv = document
      .querySelector(".configuration-price")
      .querySelector(".price-list");
    let salePriceDiv = priceDiv.querySelector("sale-price");
    let productPrice = 0;
    try {
      productPrice = parseFloat(priceDiv.getAttribute("final-price"));
    } catch (e) {
      productPrice = 0;
    }
    let temp_final_price = productPrice + 0;
    current_product_json.additional_products.forEach((itm) => {
      if (parseFloat(itm.price)) {
        temp_final_price = temp_final_price + parseFloat(itm.price);
      }
    });
    if (temp_final_price >= productPrice) {
      if (salePriceDiv?.innerHTML) {
        salePriceDiv.classList.remove("text-on-sale");
        salePriceDiv.innerHTML = currency_format.replace(
          "0.00",
          temp_final_price.toFixed(2).toString()
        );
        if (priceDiv?.querySelector("compare-at-price")) {
          priceDiv.querySelector("compare-at-price").classList.add("hidden");
        }
        if (
          document
            ?.querySelector(".dynamic-quick-add-final-price")
            ?.querySelector(".price-list")
        ) {
          let sticky_price = document
            .querySelector(".dynamic-quick-add-final-price")
            .querySelector(".price-list");
          sticky_price.innerHTML = priceDiv.innerHTML;
        }
      }
    }
  }
}

// function to change past selected options based on product changes.
function resetPastOptions() {
  var selectedValues = getCookieValue("web-variant-selected");
  if (selectedValues) {
    var arrSelected = JSON.parse(selectedValues);
    for (
      var iElementsToPointout = 0;
      iElementsToPointout < arrSelected.length;
      iElementsToPointout++
    ) {
      for (var keyElement in arrSelected[iElementsToPointout]) {
        var radioSelector =
          'div[data-option-key-name="' +
          keyElement +
          '"] input[type="radio"][value="' +
          arrSelected[iElementsToPointout][keyElement] +
          '"]';
        if (document.querySelector(radioSelector)) {
          var selectedRadio = document.querySelector(radioSelector);
          if (!isOutOfStockOption(selectedRadio)) {
            selectedRadio.click();
          }
        }
      }
    }
  }
}

// function to remove the active class from radios while the past options are selected.
function remove_custom_pdp_load_class() {
  if (document.getElementsByClassName("custom-pdp-load")) {
    let class_array = document.getElementsByClassName("custom-pdp-load");
    for (let index = 0; index < class_array.length; index++) {
      class_array[index].classList.remove("custom-pdp-load");
    }
  }
}

//old-function to re-render DOM components based on product color swatch change
function reRenderComponents(event, section_id) {
  if (event.target.value) {
    let currentSection = document.getElementById("custom_mainproduct_div");
    document
      .querySelector("#main_parent_of_dynamic_pdp")
      .classList.add("custom-pdp-load");

    let currentdesc = document.getElementById("custom_maindesc_div");
    let currentrelated = document.getElementById("customidforender");
    let langtorender = "";
    if (
      typeof current_locale_lang != "undefined" &&
      current_locale_lang != "en"
    ) {
      langtorender = "/" + current_locale_lang;
    }
    if (currentSection) {
      window.history.replaceState(
        "data",
        event.target.value,
        window.Shopify.routes.root + "products/" + event.target.value.toString()
      );
      fetch(
        langtorender +
          "/products/" +
          event.target.value +
          "?section_id=" +
          section_id
      )
        .then((res) => res.text())
        .then((res) => {
          var htmlObj = document.createElement("div");
          htmlObj.innerHTML = res;
          var dynamic_product_gallery_div = htmlObj.querySelector(
            "#dynamic_product_gallery"
          );
          var dynamic_product_info_div = htmlObj.querySelector(
            "#dynamic_product_info"
          );
          var dynamic_quickadd_form1 = htmlObj.querySelector(
            "#dynamic_quick_add_form1"
          );
          var dynamic_quickadd_form2 = htmlObj.querySelector(
            "#dynamic_quick_add_form2"
          );
          let selected_custom_material = document
            .getElementById(event.target.id)
            .getAttribute("custom-material-name");

          if (
            htmlObj.querySelector("#dynamic_product_info") &&
            typeof htmlObj.querySelector("#dynamic_product_info") !=
              "undefined" &&
            document.getElementById("dynamic_product_info") &&
            typeof document.getElementById("dynamic_product_info") !=
              "undefined"
          ) {
            document.getElementById("dynamic_product_info").innerHTML =
              dynamic_product_info_div.innerHTML;
          }
          if (
            htmlObj.querySelector("#dynamic_product_gallery") &&
            typeof htmlObj.querySelector("#dynamic_product_gallery") !=
              "undefined" &&
            document.getElementById("dynamic_product_gallery") &&
            typeof document.getElementById("dynamic_product_gallery") !=
              "undefined"
          ) {
            document.getElementById("dynamic_product_gallery").innerHTML =
              dynamic_product_gallery_div.innerHTML;
          }

          if (
            htmlObj.querySelector("#dynamic_quick_add_form1") &&
            typeof htmlObj.querySelector("#dynamic_quick_add_form1") !=
              "undefined" &&
            document.getElementById("dynamic_quick_add_form1") &&
            typeof document.getElementById("dynamic_quick_add_form1") !=
              "undefined"
          ) {
            document.getElementById("dynamic_quick_add_form1").innerHTML =
              dynamic_quickadd_form1.innerHTML;
          }
          if (
            htmlObj.querySelector("#dynamic_quick_add_form2") &&
            typeof htmlObj.querySelector("#dynamic_quick_add_form2") !=
              "undefined" &&
            document.getElementById("dynamic_quick_add_form2") &&
            typeof document.getElementById("dynamic_quick_add_form2") !=
              "undefined"
          ) {
            document.getElementById("dynamic_quick_add_form2").innerHTML =
              dynamic_quickadd_form2.innerHTML;
          }
          if (typeof selected_custom_material != "undefined") {
            if (
              !document
                .getElementById("dynamic_product_group_class")
                .classList.contains(
                  selected_custom_material.charAt(0).toUpperCase() +
                    selected_custom_material.slice(1)
                )
            ) {
              document
                .getElementById("dynamic_product_group_class")
                .classList.remove("product-Terylast", "product-Sunbrella");
              document
                .getElementById("dynamic_product_group_class")
                .classList.add(
                  "product-" +
                    selected_custom_material.charAt(0).toUpperCase() +
                    selected_custom_material.slice(1)
                );
            }
          }
        });

      if (
        typeof html_array_desc != "undefined" &&
        html_array_desc.hasOwnProperty(event.target.value)
      ) {
        let htmlString1 = html_array_desc[event.target.value];
        htmlString1 = htmlString1.replace(/##scripttagstart##/g, "<script");
        htmlString1 = htmlString1.replace(/##scripttagend##/g, "</script>");
        currentdesc.innerHTML = htmlString1;
      }

      if (
        typeof html_array_related != "undefined" &&
        html_array_related.hasOwnProperty(event.target.value)
      ) {
        let htmlString2 = html_array_related[event.target.value];
        let replaceProductId = document
          .getElementById("customidforender")
          .children[0].setAttribute("product", htmlString2.toString());
        currentrelated.innerHTML =
          document.getElementById("customidforender").innerHTML;
      }
      if (document.getElementById(event.target.id)) {
        document.getElementById(event.target.id).checked = true;
      }
      if (
        document
          .getElementById(event.target.id)
          .getAttribute("custom-material-name")
      ) {
        let selected_material = document
          .getElementById(event.target.id)
          .getAttribute("custom-material-name");
        document.getElementById(
          pdp_section_id + "-" + selected_material.toLowerCase()
        ).checked = true;
      } else if (
        document.getElementById(pdp_section_id + "-" + event.target.value)
      ) {
        document.getElementById(
          pdp_section_id + "-" + event.target.value
        ).checked = true;
      }
      setTimeout(function () {
        var reviewSummaryRating1 = document.querySelector(
          "#review-summary-rating"
        );
        if (
          typeof reviewSummaryRating1 != "undefined" &&
          reviewSummaryRating1 != null
        ) {
          var filledStars1 = document.querySelector("[data-filled-stars]");
          var calculateValue1 = (reviewSummaryRating1.value * 100) / 5;
          var calculateRatingPercentage1 = `${calculateValue1}%`;
          filledStars1.style.width = calculateRatingPercentage1;
        }
        var totalReviewCount = document.querySelector(`#review-count-total`);
        if (
          typeof totalReviewCount != "undefined" &&
          totalReviewCount != null
        ) {
          document.querySelectorAll(`.rating-score`).forEach(function (rating) {
            var currentReviewCount =
              rating.querySelector(`[data-rating-count]`).dataset.ratingCount;
            if (currentReviewCount != null) {
              var reviewPercentage =
                (parseInt(currentReviewCount) /
                  parseInt(totalReviewCount.value)) *
                100;
              rating.querySelector(`.rating_score__bar__fill`).style.width =
                reviewPercentage + "%";
            }
          });
        }
      }, 2000);
    }
  }
}

//function to re-render review widgets based on product color swatch change
function reviewWidgetReinit(params) {
  if (
    document?.querySelector("#review-summary-rating")?.value &&
    document?.querySelectorAll("[data-filled-stars]")
  ) {
    let calculateWidth =
      (document.querySelector("#review-summary-rating").value * 100) / 5;
    document.querySelectorAll("[data-filled-stars]").forEach((filledStars) => {
      filledStars.style.width = `${calculateWidth}%`;
    });
  }
  if (
    document?.querySelector(`#review-count-total`)?.value &&
    document?.querySelectorAll(`.rating-score`)?.length
  ) {
    document.querySelectorAll(`.rating-score`).forEach(function (rating) {
      var currentReviewCount =
        rating.querySelector(`[data-rating-count]`).dataset.ratingCount;
      if (
        currentReviewCount != null &&
        rating?.querySelector(`.rating_score__bar__fill`).style
      ) {
        var reviewPercentage =
          (parseInt(currentReviewCount) /
            parseInt(document.querySelector(`#review-count-total`).value)) *
          100;
        rating.querySelector(`.rating_score__bar__fill`).style.width =
          reviewPercentage + "%";
      }
    });
  }
}
var option_changes_process = false;
//function to change past selected options based on product changes after theme default code ends.
function processOptionChanges() {
  if (typeof window.Shopify.PaymentButton.init != "undefined") {
    window.Shopify.PaymentButton.init();
  }
  if (
    document?.querySelectorAll(".other-product-options")?.length &&
    current_product_json?.selected_option?.length
  ) {
    let temp_options = Object.values(current_product_json.selected_option).map(
      (itm) => itm?.value
    );
    if (temp_options?.length) {
      option_changes_process = true;
      document.querySelectorAll(".other-product-options").forEach((itm) => {
        if (temp_options.includes(itm?.value) && !isOutOfStockOption(itm)) {
          if (itm?.classList?.contains("swatch-option")) {
            itm.classList.add("selected");
          }
          itm.click();
        }
      });
      option_changes_process = false;
    }
  }

  refreshAllOptionAvailabilityStates();
  applyClearanceMode();
}

var USER_CLICKED = true;
// function to assign all the provided listeners at the time of Document load.
document.removeEventListener("DOMContentLoaded", assignListener);
document.addEventListener("DOMContentLoaded", assignListener);
document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap != "undefined" && typeof ScrollToPlugin != "undefined") {
    gsap.registerPlugin(ScrollToPlugin);
  }
  if (
    document?.querySelector(".content-step1") &&
    document
      ?.querySelector(".content-step1")
      ?.querySelectorAll(".other-product-options")?.length
  ) {
    let next_options = [];
    document
      .querySelector(".content-step1")
      .querySelectorAll(".other-product-options")
      .forEach((opt) => {
        if (opt?.id) {
          let labelObj = document
            .querySelector(".content-step1")
            .querySelector(`[for="${opt.id}"]`);
          if (
            labelObj?.classList &&
            !labelObj?.classList?.contains("other-options-hidden")
          ) {
            next_options.push(opt);
          }
        }
      });
    if (next_options?.length == 1 && next_options[0]?.classList) {
      if (!isOutOfStockOption(next_options[0])) {
        USER_CLICKED = false;
        next_options[0].classList.add("selected");
        next_options[0].click();
      }
      document.querySelector(".content-step1").classList.add("active");
    }
  }
});

var FLAG_ENABLE_RESIZE = true;
var MOBILE_VIEW_THRESHOLD = 700;
var MAX_STEP = 6;
var GSAP_DURATION = 1.1;
// function to assign listeners to all the provided radio buttons for du=ynamic varient switching.
async function assignListener() {
  if (document?.querySelectorAll(".other-product-options")?.length) {
    document.querySelectorAll(".other-product-options").forEach((element) => {
      element.removeEventListener("click", radioClicked);
      element.addEventListener("click", radioClicked);
    });
  }
  if (document?.querySelectorAll(".pagin-item")?.length) {
    document.querySelectorAll(".pagin-item").forEach((element) => {
      element.removeEventListener("click", stepClicked);
      element.addEventListener("click", stepClicked);
    });
  }
  if (document?.querySelector(".product-info-outer")) {
    document
      .querySelector(".product-info-outer")
      .addEventListener("scroll", scrollFun);
  }
  if (FLAG_ENABLE_RESIZE) {
    resizeListener("individual");
  }
  refreshAllOptionAvailabilityStates();
  applyClearanceMode();
  ensureClearanceSelection();
  //window.addEventListener("scroll", globalScroll);
}

function stepClicked(e) {
  if (
    e?.target?.getAttribute("step") &&
    document?.querySelector(
      `[progress-step="${e.target.getAttribute("step")}"]`
    )
  ) {
    if (typeof gsap != "undefined") {
      gsap.to(window, {
        duration: GSAP_DURATION,
        scrollTo: {
          y: document.querySelector(
            `[progress-step="${e.target.getAttribute("step")}"]`
          ),
          offsetY: window.innerHeight / 3,
        },
        ease: "power1.inOut",
      });
    } else {
      document
        .querySelector(`[progress-step="${e.target.getAttribute("step")}"]`)
        .scrollIntoView({
          behavior: "smooth",
        });
    }
  }
}

// function to call when a product is added to cart and additional products are found to add.
async function buyButtonClicked(formData) {
  if (
    typeof current_product_json != "undefined" &&
    current_product_json?.additional_products?.length &&
    formData?.get("quantity")
  ) {
    let addToCartFormData = [];
    current_product_json.additional_products.forEach((itm) => {
      addToCartFormData.push({
        id: itm.varientId,
        quantity: formData.get("quantity"),
      });
    });
    let addResponse = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: addToCartFormData }),
    });
  }
}
// function to selected product combination at the end of varient selection.
function baseDOMUpdate(remove = false, option_name = "") {
  if (remove && option_name != "") {
    let mainStepDiv = document.querySelector(".product-configuration-step");
    if (mainStepDiv?.querySelectorAll(".variant-item")) {
      mainStepDiv.querySelectorAll(".variant-item").forEach((itm) => {
        if (itm?.getAttribute("option-name") == option_name) {
          itm.remove();
        }
      });
    }
  } else {
    if (document?.querySelector(".product-configuration-step")) {
      let mainStepDiv = document.querySelector(".product-configuration-step");
      current_product_json.selected_option.forEach((itm) => {
        if (
          mainStepDiv?.querySelector(
            `.variant-item[option-name='${itm.name}']`
          ) &&
          itm?.value
        ) {
          let singleCoinfigDiv = mainStepDiv?.querySelector(
            `.variant-item[option-name='${itm.name}']`
          );
          let htmlString = `<span class="text-subdued">${itm.name}: </span>`;
          htmlString = htmlString + `<span>${itm.value}</span>`;
          if (singleCoinfigDiv?.innerHTML) {
            singleCoinfigDiv.innerHTML = htmlString;
          }
        } else {
          let htmlString = `<span class="text-subdued">${itm.name}: </span>`;
          htmlString = htmlString + `<span>${itm.value}</span>`;
          let config_div = document.createElement("div");
          config_div.classList.add("variant-item");
          config_div.setAttribute("option-name", itm.name);
          config_div.innerHTML = htmlString;
          if (mainStepDiv?.appendChild) {
            mainStepDiv.appendChild(config_div);
          }
        }
      });
      if (current_product_json?.additional_products?.length) {
        if (typeof accessories_label != "undefined") {
          baseDOMUpdate(true, accessories_label);
        }
        current_product_json.additional_products.forEach((singleProduct) => {
          if (
            typeof accessories_label != "undefined" &&
            singleProduct?.name != accessories_label &&
            mainStepDiv?.querySelector(
              `.variant-item[option-name='${singleProduct.name}']`
            )
          ) {
            let singleCoinfigDiv = mainStepDiv?.querySelector(
              `.variant-item[option-name='${singleProduct.name}']`
            );
            let htmlString = `<span class="text-subdued">${singleProduct.name}: </span>`;
            htmlString = htmlString + `<span>${singleProduct.value}</span>`;
            if (singleCoinfigDiv?.innerHTML) {
              singleCoinfigDiv.innerHTML = htmlString;
            }
          } else {
            let htmlString = `<span class="text-subdued">${singleProduct.name}: </span>`;
            htmlString = htmlString + `<span>${singleProduct.value}</span>`;
            let config_div = document.createElement("div");
            config_div.classList.add("variant-item");
            config_div.setAttribute("option-name", singleProduct.name);
            config_div.innerHTML = htmlString;
            if (mainStepDiv?.appendChild) {
              mainStepDiv.appendChild(config_div);
            }
          }
        });
      }
    }
  }
  if (
    document?.querySelector(".payment-terms-main")?.hasChildNodes() &&
    document?.querySelector(".payment-terms-secondary")
  ) {
    document.querySelector(".payment-terms-secondary").innerHTML =
      document.querySelector(".payment-terms-main").innerHTML;
    document.querySelector(".payment-terms-secondary").onclick = function () {
      document.querySelector(".payment-terms-main").click();
    };
  }
  if (
    document?.querySelector(".trustpilot-widget-primary")?.hasChildNodes() &&
    !document?.querySelector(".trustpilot-widget-secondary")?.hasChildNodes()
  ) {
    document.querySelector(".trustpilot-widget-secondary").innerHTML =
      document.querySelector(".trustpilot-widget-primary").innerHTML;
  }
}

function getSelectedOptionValues(selectionContext) {
  if (!selectionContext?.selected_option?.length) {
    return [];
  }
  return selectionContext.selected_option
    .map((item) => item?.value)
    .filter(Boolean);
}

function isOptionValueAvailable(selectedValues, optionValue) {
  if (typeof productJson === "undefined" || !optionValue) {
    return true;
  }

  return Object.keys(productJson).some((variantId) => {
    const variant = productJson[variantId];
    if (!variant?.selected_option?.includes(optionValue)) {
      return false;
    }

    return (
      selectedValues.every((value) => variant.selected_option.includes(value)) &&
      variant.isAvailable === true
    );
  });
}

function isOutOfStockOption(radio) {
  if (!radio) {
    return false;
  }

  if (radio.classList?.contains("out-of-stock")) {
    return true;
  }

  const label = document.querySelector(`[for="${radio.id}"]`);
  return label?.classList?.contains("out-of-stock");
}

function setOptionStockState(newRadio, labelObj, visible, available) {
  if (!newRadio?.classList || !labelObj?.classList) {
    return;
  }

  if (!visible) {
    labelObj.classList.add("other-options-hidden");
    newRadio.classList.remove("out-of-stock");
    labelObj.classList.remove("out-of-stock");
    newRadio.disabled = true;
    return;
  }

  labelObj.classList.remove("other-options-hidden");

  if (available) {
    newRadio.classList.remove("out-of-stock");
    labelObj.classList.remove("out-of-stock");
    newRadio.disabled = false;
    return;
  }

  newRadio.classList.add("out-of-stock");
  labelObj.classList.add("out-of-stock");
  newRadio.disabled = true;

  if (newRadio.classList.contains("selected")) {
    newRadio.classList.remove("selected");
    newRadio.checked = false;
  }
}

function buildMatchingOptionValues(selectionContext) {
  if (typeof productJson === "undefined") {
    return [];
  }

  const selectedValues = getSelectedOptionValues(selectionContext);
  const matchingVariantIds = Object.keys(productJson).filter((variantId) => {
    const variant = productJson[variantId];
    if (!variant?.selected_option?.length) {
      return false;
    }

    if (!selectedValues.length) {
      return true;
    }

    return selectedValues.every((value) => variant.selected_option.includes(value));
  });

  const values = [];
  matchingVariantIds.forEach((variantId) => {
    values.push(...productJson[variantId].selected_option);
  });

  return [...new Set(values)];
}

function getSelectedValuesForStep(mainDOM, stepIndex) {
  const values = [];

  for (let step = 1; step < stepIndex; step++) {
    const stepDiv = mainDOM?.querySelector(`.content-step${step}`);
    if (!stepDiv) {
      continue;
    }

    const selectedRadio = stepDiv.querySelector(
      ".other-product-options.selected:checked, .other-product-options.selected"
    );

    if (selectedRadio?.value) {
      values.push(selectedRadio.value);
    }
  }

  return values;
}

function refreshAllOptionAvailabilityStates(mainDOM = document) {
  if (typeof productJson === "undefined" || typeof current_product_json === "undefined") {
    return;
  }

  for (let index = 1; index <= MAX_STEP; index++) {
    const currentStepDiv = mainDOM?.querySelector(`.content-step${index}`);
    if (!currentStepDiv) {
      continue;
    }

    const selectedValues = getSelectedValuesForStep(mainDOM, index);
    const matchingOptionValues = buildMatchingOptionValues({
      selected_option: selectedValues.map((value) => ({ value })),
    });

    currentStepDiv
      .querySelectorAll(".other-product-options")
      .forEach((newRadio) => {
        if (
          newRadio?.classList?.contains("base-options") ||
          newRadio?.classList?.contains("accessories-options")
        ) {
          return;
        }

        const labelObj = mainDOM.querySelector(`[for="${newRadio.id}"]`);
        if (!labelObj) {
          return;
        }

        const isVisible = matchingOptionValues.includes(newRadio.value);
        const isAvailable = isOptionValueAvailable(selectedValues, newRadio.value);

        if (isClearanceMode() && newRadio.classList.contains("swatch-option")) {
          const handle = newRadio.getAttribute("product-handle");
          if (handle && !isHandleOnClearance(handle)) {
            setOptionStockState(newRadio, labelObj, false, false);
            return;
          }
        }

        setOptionStockState(newRadio, labelObj, isVisible, isAvailable);
      });
  }
}

// function to calculate step and update product selection combination
function updateProductSelection(radio) {
  let tempCurrentJSON = { ...current_product_json };
  if (
    document?.querySelectorAll(".proInfo-steps").length &&
    tempCurrentJSON?.selected_option
  ) {
    document.querySelectorAll(".proInfo-steps").forEach((step) => {
      if (
        step?.getAttribute("progress-step") &&
        step?.querySelector(`#${radio.id}`) &&
        step?.getAttribute("progress-step")
      ) {
        tempCurrentJSON.selected_option =
          tempCurrentJSON.selected_option.filter(
            (item) =>
              item?.index <= parseInt(step.getAttribute("progress-step")) &&
              item?.name != radio.getAttribute("option-name")
          );
        tempCurrentJSON.selected_option.push({
          name: `${radio.getAttribute("option-name")}`,
          value: `${radio.value}`,
          index: parseInt(step.getAttribute("progress-step")),
        });
      }
    });
  }
  return tempCurrentJSON;
}

function updateNextStepStatus(mainDOM, radio) {
  let nextDivToSlide = null;
  if (mainDOM?.querySelectorAll(".proInfo-steps") && radio?.id) {
    let stepDoms = mainDOM?.querySelectorAll(".proInfo-steps");
    let currentStep = 1;
    let flagSetNextDiv = false;
    if (stepDoms?.length) {
      stepDoms.forEach((step) => {
        if (flagSetNextDiv) {
          nextDivToSlide = step;
          flagSetNextDiv = false;
        }
        if (
          step?.getAttribute("progress-step") &&
          step.querySelector(`#${radio.id}`)
        ) {
          flagSetNextDiv = true;
          currentStep = parseInt(step.getAttribute("progress-step"));
          if (step?.querySelectorAll(".selected-option-text")?.length) {
            step.querySelectorAll(".selected-option-text").forEach((itm) => {
              itm.classList.remove("visiblity-hidden");
            });
          }
        }
      });
    }
    if (typeof currentStep == "number" && currentStep <= MAX_STEP) {
      let flag_next_div_active = false;
      for (let index = currentStep + 1; index <= MAX_STEP; index++) {
        let currentStepDiv = mainDOM?.querySelector(`.content-step${index}`);
        if (currentStepDiv?.isEqualNode(nextDivToSlide)) {
          flag_next_div_active = true;
        }
        if (currentStepDiv?.classList) {
          if (flag_next_div_active) {
            currentStepDiv.classList.remove("not-selected");
            flag_next_div_active = false;
          } else {
            currentStepDiv.classList.add("not-selected");
          }
        }
        if (
          index == currentStep + 1 &&
          currentStepDiv?.querySelector(
            ".other-product-options.default-selected"
          )
        ) {
          flag_next_div_active = true;
        }
      }
    }
  }
  return nextDivToSlide;
}

// function to be triggered whenever a dynamic product varient selector is selected.
async function radioClicked(e) {
  const radio = e?.target;

  if (isOutOfStockOption(radio)) {
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  if (
    isClearanceMode() &&
    radio?.classList?.contains("swatch-option") &&
    !isHandleOnClearance(radio.getAttribute("product-handle"))
  ) {
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  let alreadyClicked = false;
  let nextDivToSlide = null;
  if (radio?.getAttribute("name")) {
    if (
      document?.querySelectorAll(`[name="${radio.getAttribute("name")}"]`)
        ?.length
    ) {
      let radio_group = document.querySelectorAll(
        `[name="${radio.getAttribute("name")}"]`
      );
      let next_options = [];
      radio_group.forEach((radioGroup) => {
        if (radioGroup?.id) {
          let labelObj = document.querySelector(`[for="${radioGroup.id}"]`);
          if (
            labelObj?.classList &&
            !labelObj?.classList?.contains("other-options-hidden")
          ) {
            next_options.push(radioGroup);
          }
        }
        if (
          radioGroup?.classList?.contains("selected") &&
          !radio?.classList?.contains("material-option")
        ) {
          alreadyClicked = true;
        } else if (
          radio?.classList?.contains("material-option") &&
          !USER_CLICKED
        ) {
          alreadyClicked = true;
        }
        if (radioGroup?.id == radio?.id) {
          radioGroup.classList.add("selected");
        } else {
          radioGroup.classList.remove("selected");
        }
      });
      if (
        next_options?.length == 1 &&
        next_options[0]?.classList?.contains("selected") &&
        USER_CLICKED
      ) {
        alreadyClicked = false;
      }
      USER_CLICKED = true;
      if (radio?.getAttribute("sub-product-handle")) {
        if (
          document?.querySelector(
            `[main-product-handle="${radio.getAttribute(
              "sub-product-handle"
            )}"]`
          )
        ) {
          document
            .querySelector(
              `[main-product-handle="${radio.getAttribute(
                "sub-product-handle"
              )}"]`
            )
            .classList.add("selected");
        }
      }
    }
  }
  // if (document?.querySelector(".dynamic-quick-add-initial-price")?.classList) {
  //   document
  //     ?.querySelector(".dynamic-quick-add-initial-price")
  //     ?.classList.add("hidden");
  // }
  // if (document?.querySelector(".dynamic-quick-add-final-price")?.classList) {
  //   document
  //     ?.querySelector(".dynamic-quick-add-final-price")
  //     ?.classList.remove("hidden");
  // }
  if (radio?.classList?.contains("material-option")) {
    let mainDOM = document;
    let first_material_radio = null;
    if (mainDOM?.querySelectorAll(`.dynamic-material-radio`)?.length) {
      mainDOM
        .querySelectorAll(`.dynamic-material-radio`)
        .forEach((uinqueMaterial) => {
          if (radio?.value == "both-material") {
            uinqueMaterial.classList.remove("other-options-hidden");
          } else {
            if (
              uinqueMaterial?.classList?.contains(
                `dynamic-material-${radio.value}`
              )
            ) {
              uinqueMaterial.classList.remove("other-options-hidden");
              if (uinqueMaterial?.querySelectorAll("input")?.length) {
                let checked_found = false;
                uinqueMaterial.querySelectorAll("input").forEach((matradio) => {
                  if (matradio?.checked) {
                    checked_found = true;
                  }
                });
                if (
                  !checked_found &&
                  uinqueMaterial.querySelectorAll("input")[0]
                ) {
                  first_material_radio =
                    uinqueMaterial.querySelectorAll("input")[0];
                }
              }
            } else {
              uinqueMaterial.classList.add("other-options-hidden");
            }
          }
        });
    }
    if (radio?.value) {
      current_product_json = updateProductSelection(radio);
      nextDivToSlide = updateNextStepStatus(mainDOM, radio);
      baseDOMUpdate();
    }
    if (first_material_radio?.click) {
      first_material_radio.click();
    }
  } else if (radio?.value == "no-base" || radio?.value == "add-base") {
    let mainDOM = document;
    if (mainDOM?.querySelector(`.base-products`)) {
      if (radio?.value == "add-base") {
        let baseDiv = mainDOM.querySelector(`.base-products`);
        baseDiv.classList.remove("other-options-hidden");
        if (baseDiv?.querySelectorAll("input")?.length) {
          baseDiv?.querySelectorAll("input").forEach((baseoption) => {
            if (baseoption?.classList) {
              baseoption.classList.remove("selected");
              baseoption.checked = false;
            }
          });
        }
      } else {
        if (
          current_product_json?.additional_products?.filter &&
          typeof base_label != "undefined"
        ) {
          current_product_json.additional_products =
            current_product_json.additional_products.filter(
              (itm) => itm.name != base_label
            );
          updateDOMPrice();
          baseDOMUpdate(true, base_label);
        }
        mainDOM
          .querySelector(`.base-products`)
          .classList.add("other-options-hidden");
      }
    }
    nextDivToSlide = updateNextStepStatus(mainDOM, radio);
  } else if (radio?.classList?.contains("base-options")) {
    if (radio?.getAttribute("main-product-handle")) {
      if (
        document?.querySelectorAll(
          `[sub-product-handle="${radio.getAttribute("main-product-handle")}"]`
        )?.length
      ) {
        let currMainRadio = document.querySelectorAll(
          `[sub-product-handle="${radio.getAttribute("main-product-handle")}"]`
        );
        for (let j = 0; j < currMainRadio.length; j++) {
          let currSubRadio = currMainRadio[j];
          if (!currSubRadio?.classList?.contains("out-of-stock")) {
            currSubRadio.click();
            break;
          }
        }
      }
    }
    if (
      radio?.getAttribute("option-price") &&
      radio?.getAttribute("option-name") &&
      radio?.value
    ) {
      if (
        current_product_json?.additional_products?.filter &&
        typeof base_label != "undefined"
      ) {
        current_product_json.additional_products =
          current_product_json.additional_products.filter(
            (itm) => itm.name != base_label
          );
        current_product_json.additional_products.push({
          name: radio?.getAttribute("option-name"),
          value: radio?.getAttribute("product-name"),
          varientId: radio?.value,
          price: radio?.getAttribute("option-price"),
        });
        updateDOMPrice();
      }
    }
    baseDOMUpdate();
  } else if (
    radio?.value == "no-accessories" ||
    radio?.value == "add-accessories"
  ) {
    let mainDOM = document;
    if (mainDOM?.querySelector(`.accessories-products`)) {
      let accessoriesDiv = mainDOM.querySelector(`.accessories-products`);
      if (accessoriesDiv?.classList) {
        if (radio?.value == "add-accessories") {
          accessoriesDiv.classList.remove("other-options-hidden");
        } else {
          if (
            current_product_json?.additional_products?.filter &&
            typeof accessories_label != "undefined"
          ) {
            current_product_json.additional_products =
              current_product_json.additional_products.filter(
                (itm) => itm.name != accessories_label
              );
            updateDOMPrice();
            baseDOMUpdate();
          }
          if (accessoriesDiv?.querySelectorAll("input")?.length) {
            accessoriesDiv
              ?.querySelectorAll("input")
              .forEach((accessoriesOption) => {
                if (accessoriesOption?.classList) {
                  accessoriesOption.classList.remove("selected");
                  accessoriesOption.checked = false;
                }
              });
          }
          accessoriesDiv.classList.add("other-options-hidden");
        }
      }
    }
    nextDivToSlide = updateNextStepStatus(mainDOM, radio);
  } else if (radio?.classList?.contains("accessories-options")) {
    // if (radio?.getAttribute("main-product-handle")) {
    //   if (
    //     document?.querySelectorAll(
    //       `[sub-product-handle="${radio.getAttribute("main-product-handle")}"]`
    //     )?.length
    //   ) {
    //     let currMainRadio = document.querySelectorAll(
    //       `[sub-product-handle="${radio.getAttribute("main-product-handle")}"]`
    //     );
    //     for (let j = 0; j < currMainRadio.length; j++) {
    //       let currSubRadio = currMainRadio[j];
    //       if (!currSubRadio?.classList?.contains("out-of-stock")) {
    //         currSubRadio.click();
    //         break;
    //       }
    //     }
    //   }
    // }
    let allAccessories = document.querySelectorAll(
      ".other-product-options.accessories-options[main-product-handle]"
    );
    if (allAccessories?.length) {
      let final_accessories_array = [];
      allAccessories.forEach((singleaccess) => {
        let singleaccessLabel = document.querySelector(
          `[for='${singleaccess.id}']`
        );
        if (singleaccess?.checked) {
          if (
            singleaccessLabel &&
            singleaccessLabel
              ?.querySelector(".horizontal-product-swatch")
              ?.querySelectorAll("input")?.length
          ) {
            let sub_checked_found = false;
            singleaccessLabel
              .querySelector(".horizontal-product-swatch")
              .querySelectorAll("input")
              .forEach((subrdo) => {
                if (
                  subrdo?.checked &&
                  subrdo?.value &&
                  subrdo?.getAttribute("option-name") &&
                  subrdo?.getAttribute("product-name") &&
                  subrdo?.getAttribute("option-price")
                ) {
                  final_accessories_array.push({
                    name: subrdo?.getAttribute("option-name"),
                    price: subrdo?.getAttribute("option-price"),
                    value: subrdo?.getAttribute("product-name"),
                    varientId: subrdo?.value,
                  });
                  sub_checked_found = true;
                }
              });
            if (!sub_checked_found) {
              if (
                singleaccessLabel
                  ?.querySelector(".horizontal-product-swatch")
                  ?.querySelectorAll("input")?.length
              ) {
                let firstRadio = null;
                singleaccessLabel
                  .querySelector(".horizontal-product-swatch")
                  .querySelectorAll("input")
                  .forEach((subrdo) => {
                    if (
                      firstRadio == null &&
                      !subrdo?.classList?.contains("out-of-stock")
                    ) {
                      firstRadio = subrdo;
                    }
                  });
                if (
                  typeof firstRadio != "undefined" &&
                  firstRadio?.value &&
                  firstRadio?.getAttribute("option-name") &&
                  firstRadio?.getAttribute("product-name") &&
                  firstRadio?.getAttribute("option-price")
                ) {
                  firstRadio.checked = true;
                  firstRadio.classList.add("selected");
                  final_accessories_array.push({
                    name: firstRadio?.getAttribute("option-name"),
                    price: firstRadio?.getAttribute("option-price"),
                    value: firstRadio?.getAttribute("product-name"),
                    varientId: firstRadio?.value,
                  });
                }
              }
            }
          } else {
            if (
              singleaccess?.value &&
              singleaccess?.getAttribute("option-name") &&
              singleaccess?.getAttribute("product-name") &&
              singleaccess?.getAttribute("option-price")
            ) {
              final_accessories_array.push({
                name: singleaccess?.getAttribute("option-name"),
                price: singleaccess?.getAttribute("option-price"),
                value: singleaccess?.getAttribute("product-name"),
                varientId: singleaccess?.value,
              });
            }
          }
        } else {
          if (
            singleaccessLabel &&
            singleaccessLabel
              ?.querySelector(".horizontal-product-swatch")
              ?.querySelectorAll("input")
          ) {
            singleaccessLabel
              .querySelector(".horizontal-product-swatch")
              .querySelectorAll("input")
              .forEach((rdo) => {
                if (rdo?.classList) {
                  rdo.checked = false;
                  rdo.classList.remove("selected");
                }
              });
          }
        }
      });
      if (final_accessories_array) {
        if (
          current_product_json?.additional_products?.filter &&
          typeof accessories_label != "undefined"
        ) {
          current_product_json.additional_products =
            current_product_json.additional_products.filter(
              (itm) => itm.name != accessories_label
            );
        }
        current_product_json.additional_products = [
          ...current_product_json.additional_products,
          ...final_accessories_array,
        ];
        updateDOMPrice();
        baseDOMUpdate();
      }
    }
  } else {
    if (radio?.id && document?.querySelectorAll(`#${radio.id}`)?.length == 1) {
      current_product_json = updateProductSelection(radio);
      let filterProductJson = Object.keys(productJson).filter((item) =>
        current_product_json.selected_option.every((ele) =>
          productJson[item].selected_option.includes(ele.value)
        )
      );
      if (filterProductJson?.length) {
        let overAllOptionArray = [];
        filterProductJson.forEach((item) => {
          if (productJson[item]?.selected_option?.length) {
            overAllOptionArray = [
              ...overAllOptionArray,
              ...productJson[item].selected_option,
            ];
          }
        });
        let uniqOverAllOptionArray = [...new Set(overAllOptionArray)];
        const selectedValues = getSelectedOptionValues(current_product_json);
        if (uniqOverAllOptionArray?.length) {
          let mainDOM = document;
          if (!radio.classList.contains("default-product-option")) {
            if (radio?.getAttribute("product-handle")) {
              renderNewUrl(radio);
              let response = await fetch(
                appendClearanceQuery(
                  window.Shopify.routes.root +
                    "products/" +
                    radio.getAttribute("product-handle")
                )
              );
              response = await response.text();
              var overAllHtmlObj = document.createElement("div");
              overAllHtmlObj.innerHTML = response;
              mainDOM = overAllHtmlObj;
              mainDOM
                .querySelector(".product-quick-add")
                .classList.add("quick-transform");
            }
          }
          uniqOverAllOptionArray.push(
            "no-base",
            "add-base",
            "both-material",
            "no-accessories",
            "add-accessories"
          );
          // if (mainDOM?.querySelector("#dynamic_quick_add_form1")) {
          //   let quick_add_div = mainDOM.querySelector(
          //     "#dynamic_quick_add_form1"
          //   );
          //   if (quick_add_div?.querySelector("product-quick-add")?.classList) {
          //     if (filterProductJson?.length == 1) {
          //       quick_add_div
          //         ?.querySelector("product-quick-add")
          //         .classList.remove("disabled");
          //     } else {
          //       quick_add_div
          //         ?.querySelector("product-quick-add")
          //         .classList.add("disabled");
          //     }
          //   }
          // }

          let stepDoms = mainDOM?.querySelectorAll(".proInfo-steps");
          let currentStep = 1;
          if (stepDoms?.length) {
            stepDoms.forEach((step) => {
              if (
                step?.getAttribute("progress-step") &&
                step.querySelector(`#${radio.id}`) &&
                step?.classList
              ) {
                currentStep = parseInt(step.getAttribute("progress-step"));
                step.classList.add("active");
              } else {
                step.classList.remove("active");
              }
            });
          } else {
          }
          let materials_to_hide = [];
          let contains_material_div = false;
          if (typeof currentStep == "number" && currentStep <= MAX_STEP) {
            nextDivToSlide = updateNextStepStatus(mainDOM, radio);
            for (let index = 1; index <= MAX_STEP; index++) {
              let currentStepDiv = mainDOM?.querySelector(
                `.content-step${index}`
              );
              if (index >= currentStep + 1) {
                if (
                  currentStepDiv?.querySelectorAll(".other-product-options")
                    ?.length
                ) {
                  currentStepDiv
                    .querySelectorAll(".other-product-options")
                    .forEach((newRadio) => {
                      if (
                        newRadio?.classList?.contains("selected") &&
                        !newRadio?.classList?.contains("default-selected")
                      ) {
                        newRadio.classList.remove("selected");
                      }
                      if (newRadio?.classList?.contains("material-option")) {
                        contains_material_div = true;
                      }
                      let labelObj = mainDOM.querySelector(
                        `[for="${newRadio.id}"]`
                      );
                      if (
                        labelObj?.classList &&
                        !newRadio?.classList.contains("base-options") &&
                        !newRadio?.classList.contains("accessories-options")
                      ) {
                        if (uniqOverAllOptionArray?.includes(newRadio?.value)) {
                          if (
                            isClearanceMode() &&
                            newRadio.classList.contains("swatch-option")
                          ) {
                            const handle = newRadio.getAttribute("product-handle");
                            if (handle && !isHandleOnClearance(handle)) {
                              setOptionStockState(newRadio, labelObj, false, false);
                              return;
                            }
                          }
                          const isAvailable = isOptionValueAvailable(
                            selectedValues,
                            newRadio?.value
                          );
                          setOptionStockState(
                            newRadio,
                            labelObj,
                            true,
                            isAvailable
                          );
                        } else {
                          setOptionStockState(newRadio, labelObj, false, false);
                          if (
                            newRadio?.classList?.contains("material-option")
                          ) {
                            materials_to_hide.push(newRadio);
                          }
                        }
                      }
                    });
                }
              } else if (index <= currentStep) {
                if (
                  currentStepDiv?.querySelectorAll(".selected-option-text")
                    ?.length
                ) {
                  currentStepDiv
                    .querySelectorAll(".selected-option-text")
                    .forEach((optDiv) => {
                      if (optDiv?.classList) {
                        optDiv.classList.remove("visiblity-hidden");
                      }
                    });
                }
              }
            }
          }
          if (contains_material_div) {
            if (materials_to_hide?.length) {
              materials_to_hide.forEach((newRadio) => {
                if (
                  newRadio?.classList?.contains("material-option") &&
                  mainDOM?.querySelector(`.dynamic-material-${newRadio?.value}`)
                ) {
                  mainDOM
                    .querySelector(`.dynamic-material-${newRadio.value}`)
                    .classList.add("other-options-hidden");
                  if (
                    mainDOM?.querySelector(".both-material-radio-container")
                  ) {
                    mainDOM
                      .querySelector(".both-material-radio-container")
                      .classList.add("other-options-hidden");

                    if (
                      mainDOM
                        ?.querySelector(".both-material-radio-container")
                        ?.querySelector("label")
                    ) {
                      mainDOM
                        .querySelector(".both-material-radio-container")
                        .querySelector("label")
                        .classList.add("other-options-hidden");
                    }
                  }
                }
              });
            } else {
              if (mainDOM?.querySelector(".both-material-radio-container")) {
                mainDOM
                  .querySelector(".both-material-radio-container")
                  .classList.remove("other-options-hidden");
                if (
                  mainDOM
                    ?.querySelector(".both-material-radio-container")
                    ?.querySelector("label")
                ) {
                  mainDOM
                    .querySelector(".both-material-radio-container")
                    .querySelector("label")
                    .classList.remove("other-options-hidden");
                }
              }
              if (
                mainDOM?.querySelectorAll(".dynamic-material-radio")?.length
              ) {
                mainDOM
                  .querySelectorAll(".dynamic-material-radio")
                  .forEach((swatchContainer) => {
                    swatchContainer.classList.remove("other-options-hidden");
                  });
              }
            }
          }
          if (!radio?.classList?.contains("default-product-option")) {
            if (
              mainDOM?.querySelector("#custom_mainproduct_div")?.innerHTML &&
              document?.querySelector("#custom_mainproduct_div")?.innerHTML
            ) {
              if (
                mainDOM?.querySelector("#dynamic_product_info") &&
                document?.querySelector("#dynamic_product_info")
              ) {
                if (
                  document?.querySelector(".material-option.selected")?.value &&
                  mainDOM.querySelectorAll(`.dynamic-material-radio`)?.length
                ) {
                  mainDOM
                    .querySelectorAll(`.dynamic-material-radio`)
                    .forEach((uinqueMaterial) => {
                      if (
                        document.querySelector(".material-option.selected")
                          .value == "both-material"
                      ) {
                        uinqueMaterial.classList.remove("other-options-hidden");
                      } else {
                        if (
                          uinqueMaterial?.classList?.contains(
                            `dynamic-material-${
                              document.querySelector(
                                ".material-option.selected"
                              ).value
                            }`
                          )
                        ) {
                          uinqueMaterial.classList.remove(
                            "other-options-hidden"
                          );
                        } else {
                          uinqueMaterial.classList.add("other-options-hidden");
                        }
                      }
                    });
                }
                document.querySelector("#dynamic_product_info").innerHTML =
                  mainDOM.querySelector("#dynamic_product_info").innerHTML;
                if (typeof renderSezzle != "undefined") {
                  renderSezzle.init();
                }
              }
              if (
                mainDOM?.querySelector("#dynamic_product_gallery") &&
                document?.querySelector("#dynamic_product_gallery")
              ) {
                document.querySelector("#dynamic_product_gallery").innerHTML =
                  mainDOM.querySelector("#dynamic_product_gallery").innerHTML;
              }
              if (
                mainDOM?.querySelector("#dynamic_quick_add_form1") &&
                document?.querySelector("#dynamic_quick_add_form1")
              ) {
                document.querySelector("#dynamic_quick_add_form1").innerHTML =
                  mainDOM.querySelector("#dynamic_quick_add_form1").innerHTML;
              }
              if (
                mainDOM?.querySelector("#dynamic_quick_add_form2") &&
                document?.querySelector("#dynamic_quick_add_form2")
              ) {
                document.querySelector("#dynamic_quick_add_form2").innerHTML =
                  mainDOM.querySelector("#dynamic_quick_add_form2").innerHTML;
              }
            }
            if (typeof renderSezzle != "undefined") {
              renderSezzle.init();
            }
            assignListener();
            reviewWidgetReinit();
            refreshAllOptionAvailabilityStates(document);
            applyClearanceMode(document);
          }
          baseDOMUpdate();
        }
      }
    }
  }
  if (
    !alreadyClicked &&
    nextDivToSlide?.scrollIntoView &&
    !option_changes_process
  ) {
    if (!radio?.classList?.contains("swatch-option")) {
      if (typeof gsap != "undefined") {
        gsap.to(window, {
          duration: GSAP_DURATION,
          scrollTo: {
            y: nextDivToSlide,
            offsetY: window.innerHeight / 3,
          },
          ease: "power1.inOut",
        });
      } else {
        nextDivToSlide.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  } else {
    if (
      radio?.classList?.contains("swatch-option") &&
      window?.innerWidth < MOBILE_VIEW_THRESHOLD &&
      document?.querySelector(".other-product-options.material-option")
    ) {
      if (typeof gsap != "undefined") {
        gsap.to(window, {
          duration: GSAP_DURATION,
          scrollTo: {
            y: document.querySelector(".other-product-options.material-option")
              .parentElement,
            offsetY: window.innerHeight / 3 - 300,
          },
          ease: "power1.inOut",
        });
      } else {
        document
          .querySelector(".other-product-options.material-option")
          .parentElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
      }
    }
  }
}

//window.onscroll = () => {
function scrollFun(e) {
  if (document?.querySelector(".product-quick-add")) {
    document
      .querySelector(".product-quick-add")
      .classList.remove("quick-transform");
  }
  var sections = document.querySelectorAll(".proInfo-steps");
  var scrollOuter = document.querySelector(".product-info-outer");
  var dotsOuter = document.querySelector(".proinfo-pagin-outer");
  var winHeight = window.innerHeight / 3;
  var winScrollPos = window.scrollY;
  sections.forEach((section) => {
    if (section?.classList) {
      var sectionTop = section.offsetTop;
      if (winScrollPos >= sectionTop - (winHeight + 80)) {
        if (winScrollPos <= sectionTop + section.offsetHeight - winHeight) {
          section.classList.add("active");
          if (
            !section?.classList?.contains("not-selected") &&
            section?.querySelectorAll(".other-product-options")?.length
          ) {
            let next_options = [];
            let selected_found = false;
            section
              .querySelectorAll(".other-product-options")
              .forEach((opt) => {
                if (opt?.id) {
                  let labelObj = section.querySelector(`[for="${opt.id}"]`);
                  if (
                    labelObj?.classList &&
                    !labelObj?.classList?.contains("other-options-hidden")
                  ) {
                    next_options.push(opt);
                  }
                }
                if (opt?.classList?.contains("selected")) {
                  selected_found = true;
                }
              });
            if (!selected_found && next_options?.length == 1) {
              if (!isOutOfStockOption(next_options[0])) {
                USER_CLICKED = false;
                next_options[0].classList.add("selected");
                next_options[0].click();
              }
            }
          }
        } else {
          section.classList.remove("active");
        }
        if (
          section?.id &&
          dotsOuter?.querySelector(`.${section?.id}`)?.classList
        ) {
          dotsOuter.querySelector(`.${section?.id}`)?.classList.add("active");
        }
      } else if (winScrollPos < sectionTop - (winHeight + 80)) {
        section.classList.remove("active");
        if (
          section?.id &&
          dotsOuter?.querySelector(`.${section?.id}`)?.classList
        ) {
          dotsOuter
            .querySelector(`.${section?.id}`)
            ?.classList.remove("active");
        }
      }
    }
  });

  if (
    typeof last_step_index != "undefined" &&
    typeof isInViewport != "undefined" &&
    document?.querySelector(".free-return-block-fixed") &&
    document?.querySelector(".quick-add-dynamic-render")
  ) {
    if (
      !isInViewport(
        document?.querySelector(".content-step1 .product-info__price"),
        1
      ) &&
      (!document
        ?.querySelector(`span.info-step${last_step_index}`)
        ?.classList?.contains("active") ||
        !isInViewport(
          document?.querySelector(`.content-step${last_step_index}`),
          2
        ))
    ) {
      document
        .querySelector(".quick-add-dynamic-render")
        .classList.add("is-visible");
      document
        .querySelector(".free-return-block-fixed")
        .classList.add("is-visible");
    } else {
      document
        .querySelector(".quick-add-dynamic-render")
        .classList.remove("is-visible");
      document
        .querySelector(".free-return-block-fixed")
        .classList.remove("is-visible");
    }
  }
}
//}

window.addEventListener("scroll", scrollFun);
// window.scroll = scrollFun();

//Global Scroll Listener for PDP scrolling-------------
// function globalScroll() {
//   if (window?.innerWidth < MOBILE_VIEW_THRESHOLD) {
//     if (
//       typeof isInViewport != "undefined" &&
//       document?.querySelector(".free-return-block-fixed") &&
//       document?.querySelector(".quick-add-dynamic-render")
//     ) {
//       if (
//         !isInViewport(document?.querySelector(".initial-price-list"), 1) &&
//         !isInViewport(document?.querySelector(".content-step6"), 2)
//       ) {
//         document
//           .querySelector(".quick-add-dynamic-render")
//           .classList.add("is-visible");
//         document
//           .querySelector(".free-return-block-fixed")
//           .classList.add("is-visible");
//       } else {
//         document
//           .querySelector(".quick-add-dynamic-render")
//           .classList.remove("is-visible");
//         document
//           .querySelector(".free-return-block-fixed")
//           .classList.remove("is-visible");
//       }
//     }
//   } else {
//     if (
//       document?.querySelector(".free-return-block-fixed") &&
//       document?.querySelector(".quick-add-dynamic-render")
//     ) {
//       if (
//         !isInViewport(document?.querySelector(".product-info-outer"), 1) &&
//         window?.scrollY > 0
//       ) {
//         document
//           .querySelector(".quick-add-dynamic-render")
//           .classList.add("is-visible");
//         document
//           .querySelector(".free-return-block-fixed")
//           .classList.add("is-visible");
//       } else if (
//         isInViewport(document?.querySelector(".product-info-outer"), 1) ||
//         window?.scrollY <= 0
//       ) {
//         document
//           .querySelector(".quick-add-dynamic-render")
//           .classList.remove("is-visible");
//         document
//           .querySelector(".free-return-block-fixed")
//           .classList.remove("is-visible");
//       }
//     }
//   }
// }

// function to be triggered when window resizes for multiple gallery rendering
function resizeListener() {
  if (FLAG_ENABLE_RESIZE) {
    if (
      document?.querySelector("#dynamic_product_gallery") &&
      document?.querySelectorAll(".block-gallery-wrapper")?.length
    ) {
      let currentGalleryDiv = document.querySelector(
        "#dynamic_product_gallery"
      );
      let stepIndex = 0;
      document
        .querySelectorAll(".block-gallery-wrapper")
        .forEach((blockContainer) => {
          stepIndex = stepIndex + 1;
          if (window?.innerWidth < MOBILE_VIEW_THRESHOLD) {
            let currentGallery = currentGalleryDiv.innerHTML;
            currentGallery = currentGallery.replaceAll(
              'adaptive-height=""',
              ""
            );
            currentGallery = currentGallery.replaceAll("adaptive-height", "");
            if (
              currentGalleryDiv
                ?.querySelector("product-gallery")
                ?.getAttribute(`section-id`)
            ) {
              let form_id = currentGalleryDiv
                .querySelector("product-gallery")
                .getAttribute(`section-id`);
              currentGallery = currentGallery.replaceAll(
                form_id,
                `${form_id}-${stepIndex}`
              );
            }
            blockContainer.innerHTML = currentGallery;
          } else if (window?.innerWidth >= MOBILE_VIEW_THRESHOLD) {
            blockContainer.innerHTML = "";
          }
        });
    }
  }
}
